import React, { Fragment, useRef, useEffect } from 'react';
import Popup from "reactjs-popup";
import ItemScroll from '../Components/ItemScroll'
import { translate } from '../Services/translation';

const AddToCartPopup = ({ 
    model, 
    hide, 
    settings,
    showProduct
}) => {
    const modalRef = useRef(null);

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            hide();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
    <Fragment>
        {model &&
            <Popup
                open={true}
                closeOnDocumentClick={false}
            >
                <div className="add-to-cart" ref={modalRef}>
                    <div className="modal">
                        <div className="content">
                            <h3 className="add-to-cart__heading"><i className="add-to-cart__icon"></i>{translate('addtocart.addedtocart')}</h3>
                            { showProduct && (
                                <div className="add-to-cart__product-row">
                                    <img className="add-to-cart__image" src={model.product.imageUrl}></img>
                                    <div className="add-to-cart__name">{model.product.name}</div>
                                </div>
                            )}
                            <div className="add-to-cart__button-container">
                                <button className="button button--ghost" onClick={() => hide()}>{translate('addtocart.keepshopping')}</button>
                                <a href={model.checkoutUrl} className="button button--buy-button cart-pop-up">
                                    {translate('addtocart.tocheckout')}
                                    <span className="button__buy-icon"></span>
                                </a>
                            </div>
                            {model.productsPromos.length > 0 && (<div className="add-to-cart__related">
                                <h3 className="add-to-cart__heading">{model.productsPromosTitle}</h3>
                                <ItemScroll itemType="product" items={model.productsPromos} settings={settings}></ItemScroll>
                            </div>
                            )}
                        </div>
                    </div>
                </div>
            </Popup>
        }
    </Fragment>
    );
};
export default AddToCartPopup;
